export const ICS_CHAINS = ['neutron-1', 'stride-1', 'elys-1', 'comdex-1', 'dungeon-1'];

export const ICS_SECURED_CHAINS = ['neutron-1', 'stride-1', 'elys-1', 'comdex-1', 'dungeon-1'];
